<template>
  <div id="address">
    <div class="table-search-card">
      <a-button type="primary" @click="visible = true, addressData = null" icon="plus">新增地址</a-button>
    </div>
    <a-table
      :loading="tableLoading"
      ref="table"
      size="default"
      :columns="columns"
      :dataSource="addressList"
      :pagination="false"
    >
      <span slot="ifDefaultAddress" slot-scope="record">
        <a-tag v-if="record.ifDefaultAddress" color="blue">默认</a-tag>
      </span>
      <span slot="address" slot-scope="record">
        {{ record.parentCodeName }}{{ record.codeName }}
      </span>
      <span slot="action" slot-scope="record">
        <a @click="addressData = record, visible = true">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm title="确定删除？" @confirm="del(record)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <AddressSave :visible.sync="visible" :loading="loading" :addressData="addressData" @ok="handleOk"/>
  </div>
</template>
<script>
import {delAddress, insertAddress, loadAddress, updateAddress} from "@/api/account";
import AddressSave from "@/views/account/modules/AddressSave";

export default {
  components: {
    AddressSave
  },
  data () {
    return {
      tableLoading: false,
      visible: false,
      addressData: null,
      loading: false,
      addressList: [],
      columns: [
        {
          title: '',
          scopedSlots: { customRender: 'ifDefaultAddress' },
          width: '10%'
        },
        {
          title: '收货人',
          dataIndex: 'name'
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber'
        },
        {
          title: '收货地址',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '详细地址',
          dataIndex: 'detailedAddress'
        },
        {
          title: '邮编',
          dataIndex: 'postalCode'
        },
        {
          title: '',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.getAddress()
  },
  methods: {
    getAddress () {
      this.tableLoading = true
      try {
        loadAddress().then(res => {
          this.addressList = res.data
        })
      } finally {
        this.tableLoading = false
      }
    },
    del (record) {
      delAddress(record.id).then(res => {
        this.getAddress()
      })
    },
    async handleOk (data) {
      this.loading = true
      try {
        let res
        if (this.addressData) {
          res = await updateAddress({...data})
        } else {
          res = await insertAddress({...data})
        }
        const isOk = this.$HttpHandlerService.checkCode(res, true, this.addressData ? '修改成功' : '新增成功')
        if (isOk) {
          this.visible = false
          this.getAddress()
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
#address{
  border-radius: 10px;
  background: #fff;
  //padding: 40px;
  min-height: 705px;
  position: relative;
}
.empty {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 40%;
  p{
    font-size: 18px;
    color: #030303;
  }
}
</style>
